export enum EServiceType {
  /** Бесплатная публикация */
  Free = 'free',
  /** Стандарт */
  Standard = 'standard',
  /** Платная публикация */
  Paid = 'paid',
  /** Премиум публикация */
  Premium = 'premium',
  /** Колтрекинг */
  Calltracking = 'calltracking',
  /** Аукцион */
  Auction = 'auction',
  /** Топ */
  Top3 = 'top3',
}
